
import React from "react";
import { VideoError } from "./video/VideoError";
import { VideoLoading } from "./video/VideoLoading";
import { useVideoPlayback } from "./video/useVideoPlayback";

interface VideoViewerProps {
  url: string;
  onComplete?: () => void;
  fileId?: string;
  resourceId?: string;
  trackProgress?: boolean;
  onError?: (error: string) => void;
}

export function VideoViewer({ 
  url, 
  onComplete, 
  fileId, 
  resourceId, 
  trackProgress = true, 
  onError 
}: VideoViewerProps) {
  const {
    videoRef,
    error,
    loading,
    retries,
    handleRetry
  } = useVideoPlayback({
    url,
    fileId,
    resourceId,
    trackProgress,
    onComplete,
    onError
  });

  return (
    <div className="w-full h-full flex items-center justify-center bg-black relative">
      {loading && !error && <VideoLoading />}
      
      {error ? <VideoError error={error} retries={retries} onRetry={handleRetry} /> : null}
      
      <video
        ref={videoRef}
        className="max-w-full max-h-full"
        controls
        controlsList="nodownload"
        preload="metadata"
        playsInline
        data-resource-type="video"
        onContextMenu={(e) => e.preventDefault()}
      >
        Your browser does not support the video tag.
        {url && <source src={url} />}
      </video>
    </div>
  );
}
